import { safeRedirectUrl } from './checkout';

// Order placed before a hosted payment, kept in the browser so the return page knows which order
// to follow. The provider's return URL carries nothing trustworthy, so this is the only link.
const PENDING_PAYMENT_KEY = 'loop-coffee.pending_payment';

export const pendingPaymentStorage = {
  get() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(PENDING_PAYMENT_KEY));
      if (!parsed || typeof parsed.orderId !== 'string' || !parsed.orderId) return null;
      return { orderId: parsed.orderId, checkoutUrl: safeRedirectUrl(parsed.checkoutUrl) };
    } catch {
      return null;
    }
  },
  set({ orderId, checkoutUrl }) {
    try {
      window.localStorage.setItem(PENDING_PAYMENT_KEY, JSON.stringify({ orderId, checkoutUrl }));
    } catch {
      // Private mode: the redirect still happens; the return page falls back to its "no order" text.
    }
  },
  clear() {
    try {
      window.localStorage.removeItem(PENDING_PAYMENT_KEY);
    } catch {
      // ignore
    }
  },
};
